/**
 * Statsig gate for phone-only Book on behalf mobile shell (register default off in Statsig; platform-owned).
 */
export const SA_BOOK_ON_BEHALF_MOBILE_GATE = 'sa_book_on_behalf_mobile'

/** Statsig gate for optional invitee phone on Book on behalf when ET has text reminders. */
export const TRUST_AND_SAFETY_SMS_OPT_IN_GATE = 'trust_and_safety_sms_opt_in'

/** `window` CustomEvent name: detail `{ eventUuid: string }` — meeting detail refetches when it matches the open meeting. */
export const BOOK_MODAL_RESCHEDULE_COMPLETED_EVENT = 'calendly:bookModalRescheduleCompleted'

export const BOOK_MODAL_SOURCE = {
  ET_CARD: 'et_card',
  CONTACT_LIST: 'contact_list',
  CONTACT_PROFILE: 'contact_profile',
  MEETINGS_PAGE: 'meetings_page',
  CRM_SHAREABLE: 'crm_shareable',
  CRM_SHARE_AVAIL: 'crm_share_avail',
  CRM_CONTACT_CARD: 'crm_contact_card',
  CRM_CONTACT_PAGE: 'crm_contact_page',
}

export const DEFAULT_DURATION_OPTIONS = [15, 30, 45, 60]

/** Container name on the mobile form step root for shared layout rules (e.g. sticky footer). */
export const BOOK_MODAL_MOBILE_FORM_CONTAINER_NAME = 'book-modal-mobile-form'

/** Container query matching {@link BOOK_MODAL_MOBILE_FORM_CONTAINER_NAME}. */
export const bookModalMobileFormContainer = `@container ${BOOK_MODAL_MOBILE_FORM_CONTAINER_NAME}`

/** Selector for the mobile form step root (pairs with {@link BOOK_MODAL_MOBILE_FORM_CONTAINER_NAME}). */
export const bookModalMobileFormRootSelector = '[data-book-modal-mobile-form]'
